import { createContext } from 'use-context-selector';
import { BDTO } from '@helpful/network';

interface DataContextProps extends BDTO.GetBootstrapResponse {}

export const DataContext = createContext<DataContextProps>({
  chatBotWelcomeMessages: [],
  defaultPlans: [],
  experiences: [],
  faqs: [],
  hints: [],
  medicalRedirects: [],
  policy: [],
  searchShortcuts: [],
  stacks: [],
  surveys: [],
  tours: [],
  uploads: [],
});
